<template>
  <div class="content_box">
    <!--  <sessions-list v-if="showSessions"></sessions-list>  -->
    <div class="bordered-tabs d-flex justify-content-between">
      <div>
        <v-tabs
          v-if="showTabs"
          v-model="tab"
          class="mt-7"
          background-color="white"
          slider-color="var(--app-primary-color)"
          active-class="tab-active"
        >
          <template v-for="tabButton in tabsButtons.filter(t => t.showTab)">
            <v-tab
              :key="tabButton.href"
              class="tab-padding"
              :href="tabButton.href"
              @click="changeTab(tabButton)"
            >
              {{ tabButton.title }}
              <v-progress-circular
                v-if="tabButton.loading"
                class="ml-0 mr-2"
                color="primary"
                indeterminate
              ></v-progress-circular>
              <v-chip
                v-if="!tabButton.loading"
                class="ml-0 mr-2"
                label
                small
              >
                {{ tabButton.total }}
              </v-chip>
            </v-tab>
          </template>
        </v-tabs>
      </div>
      <div class="d-flex new-request-btn mt-7">
        <naj-button
          v-if="selectedTab.showNewEntry"
          color="primary"
          @click="selectedTab.newEntryClickHandler"
        >
          <v-icon left>
            mdi-plus
          </v-icon>
          {{ local.home.tabCommon.newRequest }}
        </naj-button>
        <naj-confirmation
          :show-modal="showVacationModal"
          :title="vacationModal.title"
          :message="vacationModal.message"
          :close-btn-label="local.common.close"
          @cancel="showVacationModal = false"
        ></naj-confirmation>
      </div>
    </div>
    <v-row>
      <v-col cols="12">
        <v-tabs-items v-model="tab">
          <v-tab-item
            v-if="selectedTab.componentName == 'lawsuitTab'"
            value="tab-1"
          >
            <lawsuit-tab
              ref="lawsuitTab"
              @updateTabCount="updateTabCount('lawsuitTab',$event)"
            >
            </lawsuit-tab>
          </v-tab-item>
          <v-tab-item
            v-if="selectedTab.componentName == 'casesTab'"
            value="tab-2"
          >
            <cases-tab
              ref="casesTab"
              :user-info="userInfo"
              @updateTabCount="updateTabCount('casesTab',$event)"
              @canDisplayArchivedCasesTab="checkArchivedCaseExistence()"
            >
            </cases-tab>
          </v-tab-item>
          <v-tab-item
            v-if="selectedTab.componentName == 'requestsTab'"
            value="tab-3"
          >
            <requests-tab
              ref="requestsTab"
              @updateTabCount="updateTabCount('requestsTab',$event)"
            >
            </requests-tab>
          </v-tab-item>
          <v-tab-item
            v-if="selectedTab.componentName == 'judgementsTab'"
            value="tab-4"
          >
            <judgements-tab
              ref="judgementsTab"
              :user-info="userInfo"
              @updateTabCount="updateTabCount('judgementsTab',$event)"
            >
            </judgements-tab>
          </v-tab-item>
          <v-tab-item
            v-if="selectedTab.componentName == 'decisionsTab'"
            value="tab-5"
          >
            <decisions-tab
              ref="decisionsTab"
              :user-info="userInfo"
              @updateTabCount="updateTabCount('decisionsTab',$event)"
            >
            </decisions-tab>
          </v-tab-item>
          <v-tab-item
            v-if="selectedTab.componentName == 'finalJudgementsTab'"
            value="tab-6"
          >
            <final-judgements-tab
              ref="finalJudgementsTab"
              :user-info="userInfo"
              @updateTabCount="updateTabCount('finalJudgementsTab',$event)"
            >
            </final-judgements-tab>
          </v-tab-item>
          <v-tab-item
            v-if="selectedTab.componentName == 'archivedCasesTab'"
            value="tab-7"
          >
            <archived-cases-tab
              ref="archivedCasesTab"
              :user-info="userInfo"
              @updateTabCount="updateTabCount('archivedCasesTab',$event)"
              @loadData="loadData()"
            >
            </archived-cases-tab>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SessionsList from '../upcoming-sessions/sessions-list';
import LawsuitTab from './lawsuit-tab.vue';
import RequestsTab from './requests-tab.vue';
import CasesTab from './cases-tab.vue';
import JudgementsTab from './judgements-tab.vue';
import DecisionsTab from './decisions-tab.vue';
import Vacations from '@/modules/lawsuit/services/vacations';
import { createNamespacedHelpers } from 'vuex';
import { userType, Urls } from '@/helpers/enum';
import ArchivedCasesTab from './archived-cases-tab.vue';
import FinalJudgementsTab from './final-judgements-tab.vue';

const { mapActions: mapCasesActions } = createNamespacedHelpers('CasesModule');
const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');

export default {
  components: {
    SessionsList,
    LawsuitTab,
    RequestsTab,
    CasesTab,
    JudgementsTab,
    DecisionsTab,
    ArchivedCasesTab,
    FinalJudgementsTab,
  },
  data() {
    return {
      loading: false,
      tab: null,
      selectedTab: {},
      showTabs: false,
      showSessions: false,
      cases: [],
      userInfo: {},
      userType,
      Urls,
      showVacationModal: false,
      vacationModal: {
        title: null,
        message: null,
      },
      tabsButtons: [
        {
          href: '#tab-1',
          title: this.local.home.tabs.lawsuitRequests,
          componentName: 'lawsuitTab',
          total: null,
          loading: null,
          showNewEntry: true,
          showTab: true,
          newEntryClickHandler: this.handleNewLawsuit,
        },
        {
          href: '#tab-2',
          title: this.local.home.tabs.cases,
          componentName: 'casesTab',
          total: null,
          loading: null,
          showTab: true,
        },
        {
          href: '#tab-3',
          title: this.local.home.tabs.requests,
          componentName: 'requestsTab',
          total: null,
          loading: null,
          showNewEntry: false,
          newEntryClickHandler: this.handleNewCaseRequest,
          showTab: true,
        },
        {
          href: '#tab-4',
          title: this.local.home.tabs.judgements,
          componentName: 'judgementsTab',
          total: null,
          loading: null,
          showTab: true,
        },
        {
          href: '#tab-5',
          title: this.local.home.tabs.decisions,
          componentName: 'decisionsTab',
          total: null,
          loading: null,
          showTab: true,
        },
        {
          href: '#tab-6',
          title: this.local.home.tabs.finalJudgements,
          componentName: 'finalJudgementsTab',
          total: null,
          loading: null,
          showTab: false,
        },
        {
          href: '#tab-7',
          title: this.local.home.tabs.archivedCases,
          componentName: 'archivedCasesTab',
          total: null,
          loading: null,
          showTab: false,
        },
      ],
    };
  },
  computed: {
    targetTab() {
      return this.$route.params.targetTab || this.$route.meta.targetTab;
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapGlobalActions(['getUserInfo']),
    ...mapCasesActions(['myStatistics', 'checkUserHasArchivedCases']),

    loadData() {
      this.getUserInfo().then((user) => {
        // get user type to show/hide create new request
        this.checkArchivedCaseExistence();
        const showLawsuitTab = this.isPortalPartner(user) || (user || {}).userType == this.userType.najizCitizen || (user || {}).userType == this.userType.najizLawyer || (user || {}).userType == this.userType.najizOrganization;
        this.tabsButtons[0].showNewEntry = showLawsuitTab;
        this.tabsButtons[0].showTab = showLawsuitTab;
        this.tabsButtons[2].showNewEntry = true;
        if (this.isMohPartner(user))
          this.handleTabsVisibilityForMohPartner();
        this.selectedTab = this.tabsButtons.find(t => t.href === this.targetTab && t.showTab) ?? this.tabsButtons.find(t => t.showTab);
        this.selectedTab.loading = true;
        this.tab = this.selectedTab.href.replace('#', '');
        this.showTabs = true;
        this.showSessions = !this.isPortalPartner(user);
        this.userInfo = user;
        this.tabsButtons[5].showTab = user.isEmirateUser;
      });
    },
    changeTab(tab) {
      if (tab != this.selectedTab) {
        this.selectedTab.total = null;
        this.selectedTab.loading = false;
        this.selectedTab = tab;
        this.selectedTab.loading = true;
        tab.href !== '#tab-3' ? history.pushState({}, '', process.env.VUE_APP_PUBLIC_PATH) : history.pushState({}, '', process.env.VUE_APP_PUBLIC_PATH + '//requests');
      }
    },
    handleTabsVisibilityForMohPartner() {
      this.tabsButtons.forEach((tab, index) => {
        this.$set(tab, 'showNewEntry', index === 0);
        this.$set(tab, 'showTab', index === 0);
      });
    },
    handleNewLawsuit() {
      const service = Vacations.check();

      if (service.locked) {
        this.vacationModal = {
          title: this.local.lawsuitRequest.serviceNotAvailable,
          message: service.message,
        };

        this.showVacationModal = true;
      } else {
        this.$router.push({ path: '/lawsuit-requests' });
      }
    },
    handleNewCaseRequest() {
      this.$router.push({ path: '/cases/new-case-related-request' });
    },
    updateTabCount(componentName, count) {
      this.tabsButtons.forEach((t) => {
        t.total = t.componentName == componentName ? count : null;
        t.loading = false;
      });
    },
    isMohPartner(user) {
      return (user || {}).userType == this.userType.healthAffairs || (user || {}).userType == this.userType.MOHComplianceManagement;
    },
    isPortalPartner(user) {
      return (user || {}).userType == this.userType.najizServicesCenter || this.isMohPartner(user);
    },
    checkArchivedCaseExistence() {
      this.loading = true;
      this.checkUserHasArchivedCases()
        .then(({ data }) => {
          this.loading = false;
          this.tabsButtons[6].showTab = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/partials/_mixins.scss';
.bordered-tabs {
  border-bottom: 1px solid #dbdbdb;
}

@include md-down {
  .bordered-tabs {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding-bottom: 16px;

    > div:first-child {
      width: 100%;
      min-width: 0;
      overflow: hidden;
    }

    .new-request-btn {
      width: 100%;
      margin-top: 0 !important;
      flex-shrink: 0;
    }
  }

  .tab-padding {
    font-size: 13px;
    padding-bottom: 12px;
    padding-right: 10px;
    padding-left: 10px;
    white-space: nowrap;
  }

  ::v-deep .v-tabs {
    width: 100%;

    .v-tabs-bar {
      width: 100%;
    }

    .v-slide-group__wrapper {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
  }
}

.tab-padding {
  font-size: 18px;
  padding-bottom: 16px;
  padding-right: 24px;
  padding-left: 24px;
  color: var(--app-dark-primary-color) !important;
  .v-chip {
    cursor: pointer;
    color: #ffffff;
    background: var(--app-dark-primary-color) !important;
    border-radius: 0px !important;
  }
}
.tab-active {
  color: var(--app-primary-color) !important;
  font-weight: bold;
  // border-right: 2px solid var(--app-lighter-primary-color);
  .v-chip {
    background: var(--app-primary-color) !important;
  }
}

::v-deep .v-tabs {
  .v-tabs-bar {
    // border-bottom: 1px solid #e8e8e8 !important;
    .v-tabs-slider-wrapper {
      height: 5px !important;
    }
  }
}

.info-item-box {
  display: flex;
  justify-content: space-between;
  flex: 1;
  padding-left: 20px;
}

.info-item {
  background-color: var(--app-light-secondary-color);
  padding: 15px 10px;
  justify-content: center;
  padding-left: 30px;
  margin-left: 10px;
}

.info-item-details {
  padding: 15px 10px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1;
}
::v-deep .naj-append {
  color: var(--app-dark-primary-color);
  i {
    color: var(--app-dark-primary-color);
  }
}

.new-request-btn {
  justify-content: flex-end;

  &::v-deep .naj-button {
    margin: 0 !important;
  }
}

.about-link {
  color: #144afa;
  display: inline;
}
</style>